import React from 'react';
import { Card, CardContent, CardHeader } from 'porosys-ui';
import './styles.scss';

const cardLayout = props => {
    const { header, content, classes } = props;
    return (
        <Card classes={{ root: `card main-card-layout ${classes}` }}>
            <CardHeader classes={{ root: 'header' }}>{header}</CardHeader>
            <CardContent classes={{ root: 'content' }}>{content}</CardContent>
        </Card>
    );
};

export default cardLayout;
